export const API_URL='https://retail.prodapi.silverandgem.co.in/v1/graphql'
export const MESSAGE_CODES = {
    SAME_PROFILE_EXIST: 'SAME_PROFILE_EXIST',
    CREATE_NEW_PROFILE: 'CREATE_NEW_PROFILE',
    BAD_REQUEST: 'BAD_REQUEST',
    PROFILE_EXIST: 'PROFILE_EXIST',
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    OTP_EXPIRED: 'OTP_EXPIRED',
    OTP_NOT_MATCH: 'OTP_NOT_MATCH'
  };
  export const BUCKET_CDN={
    GCP:{
        PUBLIC:{
            "gosbfy-public-dev":"https://storage.googleapis.com/gosbfy-public-dev/"
        }
    }
}

export const AWS_URL='https://jewel-ecom.s3.ap-south-1.amazonaws.com/'




export const REDIRECT_URL= 'https://silverandgem.co.in'
// export const REDIRECT_URL='http://localhost:8080'
